import { request } from "../../utils/axios";

export const login = async (form: { email: string; password: string }) => {
  try {
    const res = await request.post(`login`, form);
    return res?.data;
  } catch (error: any) {
    // If we have a response from the server, pass it through
    if (error?.response?.data) {
      throw error.response.data;
    }
    // If it's a network error (no response), throw a descriptive fallback
    throw new Error("Network connection error. Please check your internet or API configuration.");
  }
};

export const logout = async () => {
  try {
    const res = await request.post(`register`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
export const forgotPassword = async (data: { email: string }) => {
  try {
    const res = await request.post(`forgot-password`, data);
    return res?.data;
  } catch (error: any) {
    if (error?.response?.data) {
      const errData = error.response.data;
      throw new Error(errData?.error?.message || errData?.message || "An error occurred");
    }
    throw new Error("Network connection error. Please check your internet or API configuration.");
  }
};

export const validateToken = async (token: string) => {
  try {
    const res = await request.get(`validate-reset-token?token=${token}`);
    return res?.data;
  } catch (error: any) {
    if (error?.response?.data) {
      const errData = error.response.data;
      throw new Error(errData?.error?.message || errData?.message || "An error occurred");
    }
    throw new Error("Network connection error. Please check your internet or API configuration.");
  }
};

export const resetPassword = async (data: any) => {
  try {
    const res = await request.post(`reset-password`, data);
    return res?.data;
  } catch (error: any) {
    if (error?.response?.data) {
      const errData = error.response.data;
      throw new Error(errData?.error?.message || errData?.message || "An error occurred");
    }
    throw new Error("Network connection error. Please check your internet or API configuration.");
  }
};
